<div class="a-title">NUEVA RESERVA</div>

<form [formGroup]="group" class="a-w1-column py-2">

    <div class="a-w1-row">

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="shipper" [options]="ListaShipper" optionLabel="nombre" [filter]="true"
                [showClear]="!readonlyinput" styleClass="w-full" [readonly]="readonlyinput"
                (onChange)="listarCommodity()">
            </p-select>
            <label for="on_label">Shipper</label>
        </p-floatLabel>

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="origen" [options]="ListaPuertoOrigen" styleClass="w-full" optionLabel="nombre"
                filter="true" showClear="true" (onFilter)="onFilter($event,'origen')" (onChange)="listarNave()"
                virtualScroll="true" virtualScrollItemSize="36">
            </p-select>
            <label for="float-label">Origen</label>
        </p-floatLabel>

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="destino" [options]="ListaPuertoDestino" styleClass="w-full" optionLabel="nombre"
                filter="true" showClear="true" (onFilter)="onFilter($event,'destino')" (onChange)="listarNave()"
                virtualScroll="true" virtualScrollItemSize="36">
            </p-select>
            <label for="float-label">Destino</label>
        </p-floatLabel>

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="via" [options]="ListaVia" styleClass="w-full" optionLabel="nombre"
                inputId="float-label" [filter]="true" [showClear]="!readonlyinput" [readonly]="readonlyinput">
            </p-select>
            <label for="float-label">Via</label>
        </p-floatLabel>

    </div>

    <div class="a-w1-row">

        <div class="a-w4 flex gap-2 align-items-center" *ngIf="group?.value.via && group?.value.via.codigo == '001'">
            <p-floatLabel class="w-full" variant="on">
                <input formControlName="contenedores" class="w-full" type="number" pInputText />
                <label for="on_label">Cantidad Contenedores</label>
            </p-floatLabel>
            <div class="text-sm">x40’RH</div>
        </div>

        <div class="a-w4" *ngIf="group?.value.via && group?.value.via.codigo == '002'">
            <p-floatLabel class="w-full" variant="on">
                <input formControlName="skids" type="text" pInputText class="w-full" />
                <label for="on_label">Cantidad Skids</label>
            </p-floatLabel>
        </div>

        <p-floatLabel class="a-w4" variant="on">
            <input formControlName="bl" type="text" pInputText [readonly]="readonlyinput" class="w-full" />
            <label for="on_label">Emisión B/L</label>
        </p-floatLabel>

        <p-floatLabel class="a-w4" variant="on">
            <input formControlName="booking" type="text" pInputText class="w-full" />
            <label for="on_label">N° Booking</label>
        </p-floatLabel>

    </div>

    <div class="a-w1-row">

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="naviera" [options]="ListaNaviera" optionLabel="nombre" [filter]="true"
                [showClear]="true" (onChange)="listarNave()" styleClass="w-full">
            </p-select>
            <label for="naviera">Naviera/Aerolinea</label>
        </p-floatLabel>

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="semana" [options]="ListaSemanas" optionLabel="codigo" [filter]="true"
                [showClear]="!readonlyinput" [readonly]="readonlyinput" (onChange)="listarNave()" styleClass="w-full">
            </p-select>
            <label for="semana">Semana</label>
        </p-floatLabel>

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="nave" [options]="ListaNave" styleClass="w-full" optionLabel="nombre"
                [filter]="true" [showClear]="true">
            </p-select>
            <label for="nave">Nave</label>
        </p-floatLabel>

        <p-floatLabel class="a-w4" variant="on">
            <p-select formControlName="commodity" [options]="ListaCommodity" optionLabel="nombre" [filter]="true"
                styleClass="w-full" [showClear]="!readonlyinput" [readonly]="readonlyinput">
            </p-select>
            <label for="commodity">Commodity</label>
        </p-floatLabel>

    </div>

    <div class="a-w1-row">

        <div class="a-w4">
            <div class="a-w1-row">

                <div class="a-w2">
                    <div class="flex gap-2 align-items-center">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <input formControlName="neto" type="number" pInputText [readonly]="readonlyinput"
                                class="w-full md:w-56" />
                            <label for="on_label">Peso Neto</label>
                        </p-floatLabel>
                        <div class="text-sm">Kg</div>
                    </div>
                </div>
                <div class="a-w2">
                    <div class="flex gap-2 align-items-center">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <input formControlName="temperatura" type="number" pInputText class="w-full md:w-56" />

                            <label for="on_label">Temperatura</label>
                        </p-floatLabel>
                        <div class="text-sm">°C</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="a-w4">
            <div class="a-w1-row">
                <div class="a-w2">
                    <div class="flex gap-2 align-items-center">
                        <p-floatLabel class="w-full md:w-56" variant="on">
                            <input formControlName="ventilacion" type="number" pInputText [readonly]="readonlyinput"
                                class="w-full md:w-56" />
                            <label for="on_label">Ventilación</label>
                        </p-floatLabel>
                        <div class="text-sm">%</div>
                    </div>
                </div>
                <div class="a-w2">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <input formControlName="humedad" type="number" pInputText [readonly]="readonlyinput"
                            class="w-full md:w-56" />
                        <label for="on_label">Humedad</label>
                    </p-floatLabel>
                </div>
            </div>
        </div>

        <div class="a-w4">
            <div class="a-w1-row">
                <div class="a-w2">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <input formControlName="consignatario" type="text" pInputText [readonly]="readonlyinput"
                            class="w-full md:w-56" />
                        <label for="on_label">Consignatario</label>
                    </p-floatLabel>

                </div>
                <div class="a-w2">
                    <p-floatLabel class="w-full md:w-56" variant="on">
                        <input formControlName="remarks" type="text" pInputText [readonly]="readonlyinput"
                            class="w-full md:w-56" />
                        <label for="on_label">Remarks</label>
                    </p-floatLabel>
                </div>
            </div>
        </div>

        <div class="a-w4">
            <p-floatLabel class="w-full" variant="on">
                <p-select formControlName="flete" [options]="ListaFlete" styleClass="w-full" optionLabel="nombre"
                    [filter]="true" [showClear]="!readonlyinput" [readonly]="readonlyinput">
                </p-select>
                <label for="on_label">Flete</label>
            </p-floatLabel>
        </div>

    </div>

    <div class="a-w1-row">

        <div class="a-w4">
            <div class="a-w1-row justify-content-center">
                <div>Reseteo Temperatura</div>
                <div class="flex align-items-center center">
                    <p-radioButton name="reseteotemp" value=1 formControlName="reseteotemp"
                        [disabled]="readonlyinput"></p-radioButton>
                    <label class="ml-2">Si</label>
                </div>
                <div class="flex align-items-center center">
                    <p-radioButton name="reseteotemp" value=0 formControlName="reseteotemp"
                        [disabled]="readonlyinput"></p-radioButton>
                    <label class="ml-2">No</label>
                </div>
            </div>
        </div>

        <div class="a-w4">
            <div class="a-w1-row justify-content-center">
                <div>Atmosfera Controlada</div>
                <div class="flex align-items-center center">
                    <p-radioButton name="atmcontrolada" value=1 formControlName="atmcontrolada"></p-radioButton>
                    <label for="ingredient1" class="ml-2">Si</label>
                </div>
                <div class="flex align-items-center center">
                    <p-radioButton name="atmcontrolada" value=0 formControlName="atmcontrolada"></p-radioButton>
                    <label for="ingredient2" class="ml-2">No</label>
                </div>
            </div>
        </div>

        <div class="a-w4">
            <div class="a-w1-row justify-content-center">
                <div>Cold Treatment</div>
                <div class="flex align-items-center center">
                    <p-radioButton name="coldtreatment" value=1 formControlName="coldtreatment"></p-radioButton>
                    <label for="ingredient1" class="ml-2">Si</label>
                </div>
                <div class="flex align-items-center center">
                    <p-radioButton name="coldtreatment" value=0 formControlName="coldtreatment"></p-radioButton>
                    <label for="ingredient2" class="ml-2">No</label>
                </div>
            </div>
        </div>

        <div class="a-w4">
            <p-floatLabel class="w-full" variant="on">
                <p-select formControlName="servicio" [options]="ListaServicio" styleClass="w-full" optionLabel="nombre"
                    [filter]="true" optionValue="codigo">
                </p-select>
                <label for="on_label">Servicio</label>
            </p-floatLabel>
        </div>
    </div>

    <div class="a-w1-row">

        <div class="a-w4" *ngIf="group?.value.reseteotemp == 1">
            <div class="a-w1-row">
                <div class="a-w2">
                    <p-floatLabel class="w-full" variant="on">
                        <input formControlName="restemperatura" type="number" pInputText class="w-full" />
                        <label for="on_label">Temperatura</label>
                    </p-floatLabel>

                </div>
                <div class="a-w2">
                    <p-floatLabel class="w-full" variant="on">
                        <input formControlName="cantidad" type="number" pInputText class="w-full" />
                        <label for="on_label">Cantidad Días</label>
                    </p-floatLabel>

                </div>
            </div>
        </div>

        <div class="a-w4" *ngIf="group?.value.atmcontrolada == 1">
            <p-floatLabel class="w-full" variant="on">
                <p-select formControlName="tecnologia" [options]="ListaTecnologias" optionLabel="nombre"
                    styleClass="w-full" [filter]="true" [showClear]="true">
                </p-select>
                <label for="on_label">Tecnologia</label>
            </p-floatLabel>
        </div>

        <div class="a-w4" *ngIf="group?.value.atmcontrolada == 1">
            <div class="a-w1-row">
                <div class="a-w2">
                    <p-floatLabel class="w-full" variant="on">
                        <input formControlName="o2" type="number" pInputText class="w-full" />
                        <label for="on_label">02</label>
                    </p-floatLabel>

                </div>
                <div class="a-w2">
                    <p-floatLabel class="w-full" variant="on">
                        <input formControlName="co2" type="number" pInputText class="w-full" />
                        <label for="on_label">C02</label>
                    </p-floatLabel>

                </div>
            </div>
        </div>
        <div class="a-w4" *ngIf="group?.value.flete && group?.value.flete.codigo == '003'">
            <p-floatLabel class="w-full" variant="on">
                <input formControlName="pagadero" type="text" class="w-full" pInputText [readOnly]="readonlyinput" />
                <label for="on_label">Pagadero</label>
            </p-floatLabel>
        </div>

    </div>

     <div class="a-w1-row">
         <div class="a-w2">

             <div class="a-w1-row">
               <div class="a-w2">
 
                        <div class="flex gap-2 align-items-center">
                                    <p-floatLabel class="w-full md:w-56" variant="on">
                                        <p-select formControlName="modalidad" [options]="ListaModalidad" styleClass="w-full" optionLabel="nombre"
                                            [filter]="true" optionValue="codigo">
                                        </p-select>
                                        <label for="on_label">Modalidad</label>
                                    </p-floatLabel>
                        </div>
                 </div>
              </div>       
        </div>
     </div>

        



      <div class="a-w1-row">

         <p-checkbox formControlName="clausula"   binary="true" ></p-checkbox>
         <label for="size_normal">Al aceptar el presente booking, aceptan y declaran haber solicitado todos los servicios que en este documento se indican y estar conforme con los términos y condiciones estipulados en el mismo</label>
      </div>

    <div class="a-w1-row justify-content-center">
        <p-button label="Vista Previa" icon="pi pi-eye" (onClick)="viewPDF()" size="small"></p-button>
        <p-button label="Guardar y Enviar" icon="pi pi-save" (onClick)="guardar()" size="small"  [disabled]="!group.get('clausula')?.value"></p-button>
        <p-button label="Cancelar" icon="pi pi-external-link" (onClick)="salir()" size="small" ></p-button>
    </div>
</form>
<div class="a-footer"></div>